module.exports = __webpack_public_path__ + "static/media/work-safety-quiz.eacb1bd8.jpg";